import { ContentList, ContentListNode } from "components/article-list";
import React from "react";
import { ContentType } from "utils/enums";
import * as styles from "./author-reviewer.module.scss";
import { SubscribeBanner } from "components/subscribe-banner";

type AuthorReviewerLastSectionProps = {
  fullName: string;
  articles: ContentListNode[];
  currentPage: number;
  numPages: number;
  urlSubscribe?: string;
  nameLink?: string;
};
const AuthorReviewerLastSection = ({
  fullName,
  articles,
  currentPage,
  numPages,
  urlSubscribe,
  nameLink,
}: AuthorReviewerLastSectionProps) => (
  <div className={styles.lastSection}>
    <div>
        <div className={styles.articlesTitle}>
          Recent articles from {fullName}
        </div>  
      <ContentList
        currentPage={currentPage}
        numPages={numPages}
        items={articles}
        listType={ContentType.article}
      />
    </div>
    {urlSubscribe && nameLink && (
     <SubscribeBanner nameLink={nameLink} link={urlSubscribe} />
    )}
  </div>
);

export { AuthorReviewerLastSection };
